var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.75C4.999 11.75 4.99799 11.75 4.99699 11.75C4.79699 11.749 4.60599 11.669 4.46499 11.526L0.464993 7.46401C0.173993 7.16901 0.177996 6.69404 0.472996 6.40304C0.767996 6.11304 1.24399 6.11603 1.53399 6.41103L5.003 9.93502L14.469 0.469018C14.762 0.176018 15.237 0.176018 15.53 0.469018C15.823 0.762018 15.823 1.23705 15.53 1.53005L5.53 11.5301C5.39 11.6711 5.199 11.75 5 11.75Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.324d104fb2db150073666f884884c7c5.svg";